import React from 'react';
import logo from '../images/logo.png';

export default function Header({ onNav }) {
  return (
    <div className="header">
      <div className="container">
        <div className="header-inner">
          <div className="logo-wrap" style={{ cursor: 'pointer' }} onClick={() => onNav('home')}>
            <div className="h-20 w-20 mr-4">
              <img src={logo} alt="Basaveshwar Pre-Primary School Logo" />
            </div>
            <div className="logo-text">
              <h1>BASAVESHWAR <span>Pre-Primary School</span></h1>
              <p>Belur - Chikkanasabi</p>
            </div>
          </div>
          <div className="header-contacts">
            <div className="contact-item">
              <div className="contact-icon blue">📞</div>
              <div>
                <div className="contact-label">Call Us</div>
                <div className="contact-val">+91 8553852843</div>
                <div className="contact-val">+91 9535487630</div>
              </div>
            </div>
            <div className="contact-item">
              <div className="contact-icon green">✉️</div>
              <div>
                <div className="contact-label">Email Us</div>
                <div className="contact-val">info@basaveshwarpsch.in</div>
              </div>
            </div>
            <div className="contact-item">
              <div className="contact-icon orange">📍</div>
              <div>
                <div className="contact-label">Our Location</div>
                <div className="contact-val">Belur - Chikkanasabi</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
